import axios from 'axios';
import { server } from "../utils/server";
const getBankFromIFSCCode = (ifsc) =>{
    return axios.get(`https://ifsc.razorpay.com/${ifsc}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err)
        return err?.response?.data;
    })
}
const getBankAccount = (entityId) => {
    return server.get(`bankAccount/getBankAccount/${entityId}`)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}
const createBankAccount = (data) => {
    return server.post("bankAccount/createAccount", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}
const updatePrimaryBankAccount = (data) => {
    return server.post("bankAccount/updateBankAccount", data)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const removeBankAccount = (data) => {
    return server.post("bankAccount/removeBankAccount", data, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    })
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const getBankAccountByStatus = (entityId , status) => {
    return server.get(`bankAccount/getBankAccount/${entityId}?status=${status}`)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const updateBankAccount = (id,data) => {
    return server.post(`bankAccount/updateAccount/${id}`, data)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}



const bankServices ={
    getBankFromIFSCCode,
    getBankAccount,
    createBankAccount,
    updatePrimaryBankAccount,
    removeBankAccount,
    getBankAccountByStatus,
    updateBankAccount
}

export default bankServices;